import React from 'react';
import AdminRouteGuard from '../../components/guards/AdminRouteGuard';
import CreateAgentPage from './CreateAgentPage';

const CreateAgentPageWrapper: React.FC = () => {
  return (
    <AdminRouteGuard>
      <CreateAgentPage />
    </AdminRouteGuard>
  );
};

export default CreateAgentPageWrapper;